import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled, { withTheme } from 'styled-components';
import update from 'immutability-helper';
import * as _ from 'lodash';
import AggressiveMeasurementAlertPrompt from 'common/components/organisms/AlertPrompt';
import Accordion from 'common/components/molecules/Accordion';
import { toastr } from 'react-redux-toastr';
import RBAC from 'common/rbac/RBAC';
import { isPartnerAdmin, isPetasenseAdmin, isPetasenseViewer } from 'common/rbac/util';
import { withTranslation } from 'react-i18next';
import { Grid, Segment, Popup } from 'semantic-ui-react';
import {
  ResourceSection,
  ResourceItemLabel,
  ResourceItem,
  ResourceInputField,
  ResourceSubSection
} from 'common/components/atoms/ResourceDetails';
import { ENDPOINT, getDeviceGCPLogsUrl, getFullEndPointUrl, getImpUrl } from 'common/constants';
import { getBaseUrl } from 'home/DomainName/DomainConstants';
import {
  resolveSiteAccountId,
  resolveOrganisationId,
  hasDeviceMachineAssociation,
} from '../../utils/siteReassignUtils';
import SiteReassignSection from '../SiteReassignSection';
import * as sensorsActions from '../../actions/sensors.actions';
import * as eventConfigActions from '../../actions/eventConfig.actions';
import { localTimeString } from '../../../../common/helpers/time';
import LoadingSvg from '../../../../common/images/LoadingSvg';
import FlexContainer from '../../../../common/components/atoms/FlexContainer';
import CrossSvg from '../../../../common/images/CrossSvg';
import H1_T from '../../../../common/typography/H1/H1';
import H3 from '../../../../common/typography/H3/H3';
import H4 from '../../../../common/typography/H4/H4';
import Label_T from '../../../../common/typography/Label/Label';
import Button_T from '../../../../common/components/atoms/Button';
import { BatteryIcon } from '../../../../common/images/BatteryIcon';
import WiFiSvg from '../../../../common/images/WiFiSvg';
import { Info, ToggleOn, ToggleOff } from '../../../../common/images/FaIcons';
import Modal from '../../../../common/components/organisms/Modal';
import MeasurementScheduleModal from '../MeasurementScheduleModal';
import MoteOrientationGuide from '../../MoteOrientationGuide';
import * as sensorUtils from '../../utils/sensorUtils';
import {
  translateScheduleTypeLabel,
  translateFsRangeLabel,
  translateMagnetometerFsRangeLabel,
  translateSensorSelectOptions,
} from '../../utils/sensorMeasurementDisplay';
import {
  AGGRESSIVE_INTERVAL_THRESHOLD,
  ErrorMessages,
  vibrationMeasurementTypeEnum,
  vibrationMeasurementBlocks
} from '../../constants/sensors.constants';
import WifiSetting from '../WifiSettings';
import DeviceParameterAnalysis from '../DeviceParameterAnalysis';
import { humanize, history } from '../../../../common/helpers';
import DeviceReportedInfoModal from '../DeviceReportedInfoModal';
import PreferredAPSettings from '../PreferredAPSettings';
import EventDetectionSection from '../EventDetection';
import { areEventDetectionsEqual } from '../../utils/validationUtils';
import { toDeviceFormat } from '../../utils/eventConfigTransform';
import { stripDebugModeKeys } from '../../utils/debugModeUtils';
import { getWifiScheduleState, isWifiConfigChanged, isWifiScheduleInPast } from '../../utils/wifiSchedule';


const Container = styled(FlexContainer).attrs({ direction: 'column' })`
  padding: 2em;
  min-height: Calc(100vh - var(--title-bar-offset, 0px) - 138px);
`;
const H1 = styled(H1_T)`
  padding: ${props => (props.padding ? `${props.padding};` : '0;')};
  margin-bottom: 3px;
  min-width: max-content;
  width: 100%;
  cursor: pointer;
`;
const WifiLabel = styled(H3)`
  padding-left: 0.5em;
  padding-top: 0.1em;
`;
const SvgContainer = styled.span`
  cursor: pointer;
  margin-left: auto;
`;
const Button = styled(Button_T)`
  width: max-content;
  z-index: 2;
  padding-left: ${props => props.paddingLeft ? props.paddingLeft : '95px'};
  ${props => props.fontsize && `font-size: ${props.fontsize};`}
  ${props => props.paddingBottom && `padding-bottom: ${props.paddingBottom};`}
  ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
  ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const SaveButton = styled(Button_T)`
  max-width: 200px;
  ${props => props.fontsize && `font-size: ${props.fontsize};`}
  ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
  ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const ScheduleButton = styled(Button_T)`
  width: max-content;
  ${props => props.fontsize && `font-size: ${props.fontsize};`}
  ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
  ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const AnalysisButton = styled(Button_T)`
 width: max-content;
 ${props => props.fontsize && `font-size: ${props.fontsize};`}
 ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
 ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const LoadingContainer = styled.div`
  align-self: center;
  margin: auto;
`;
const ReportingExplainer = styled.span`
  display: block;
  margin-top: 6px;
  font-size: 0.82em;
  font-style: italic;
  color: #6b7280;
`;
const BorderContainer = styled.div`
  border: 2px solid #f0f0f0;
  padding: 20px;
`;
const AbsoluteLoading = styled.div`
  background: white;
  position: absolute;
  align-self: center;
  margin: auto;
  opacity: 0.4;
  width: 100%;
  height: calc(100vh - var(--title-bar-offset, 0px) - 138px);
  overflow: none;
  svg {
    transform: translateX(35vw) translateY(50vh) translateY(-69px);
  }
`;
const ButtonsContainer = styled(FlexContainer)`
  padding-top: 2em;
  button:first-child {
    margin-right: 15px;
  }
`;
const TextLabel = styled(Label_T)`
  font-weight: 600;
  margin-bottom: 0;
  margin-left: 8px;
  margin-top: -2px;
`;
const HeaderContainer = styled(FlexContainer).attrs({
  justifyContent: 'space-between',
  alignItems: 'center'
})``;
const ToggleWrapper = styled.span`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  opacity: ${props => (props.disabled ? 0.7 : 1)};
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: ${props => (props.disabled ? 0.7 : 0.9)};
  }
  font-size: 1.5em;
`;
const DebugHintLabel = styled(TextLabel)`
  margin-top: 4px;
  display: block;
`;
const aggressive_measurement_types = ['full_bandwidth', 'high_res'];
// Models whose firmware reads the wifi_backoff config key. `details.model` is
// the serial prefix (serial_number.split('-')[0]), so an -IS unit reports as
// VM4P or GSP and is covered by those entries — the -IS entries never match and
// are kept only for consistency with the other model lists in this file.
const WIFI_BACKOFF_MODELS = ['VM4', 'VM4P', 'GS', 'GSP', 'VM4P-IS', 'GSP-IS'];
// LIS3MDL ranges in gauss; the backend enum (SensorSensitivityEnum) is the source.
const ACCELEROMETER_FS_RANGES = [4, 8, 16];
const MAGNETOMETER_FS_RANGES = [4, 8, 12, 16];
// Exported under a distinct name (not `VibrationMote`) so the schedule helpers
// can be unit tested without a store, while consumers keep default-importing
// the connected component as `VibrationMote` without tripping
// import/no-named-as-default.
export class VibrationMoteBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        machine: props.machines || [],
        component: [],
        location: [],
        orientation: [],
        spectrum_sampling_resolution: [],
        spectrum_measurement_type: [],
        aggressiveModal: false
      },
      details: {
        serial_number: props.sensor.serial_number,
        model: props.sensor.model,
        agent_url: props.sensor.agent_url,
        device_id: props.sensor.device_id,
        mac_address: props.sensor.mac_address,
        fs_range: props.sensor.fs_range,
        magnetometer_fs_range: props.sensor.magnetometer_fs_range,
        user: this.props.user,
        id: props.sensor.id,
        account_id: props.sensor.account_id,
        temperature_only: props.sensor.temperature_only || false,
        last_battery_change_time: props.sensor.last_battery_change_time,
        event_detection: props.sensor.event_detection || null
      },
      force_association: false,
      error: false,
      openScheduler: false,
      editMode: props.editMode,
      saveEnabled: false,
      loading: {},
      maxReportingInterval: null,
      ssid: '',
      passphrase: '',
      ...getWifiScheduleState(null),
      errorMessages: {},
      showLogAnalysisModal: false,
      showLastReportedModal: false,
      bssid: '',
      channel: null,
      eventDetectionValidationValid: true
    };
  }

  getSiteAccountId = () => resolveSiteAccountId({
    details: this.state.details,
    sensor: this.props.sensor,
    currentAccount: this.props.currentAccount,
  });

  getOrganisationId = () => resolveOrganisationId({
    details: this.state.details,
    sensor: this.props.sensor,
    currentAccount: this.props.currentAccount,
  });

  getTransferDeviceParams = () => {
    const { sensor } = this.props;
    const deviceId = (this.state.details && this.state.details.id != null)
      ? this.state.details.id
      : (sensor && sensor.id);
    if (deviceId == null) return null;
    return { device_type: 'mote', device_id: deviceId };
  };

  hasMachineAssociationForReassign = () => hasDeviceMachineAssociation({
    details: this.state.details,
    associatedMachineId: this.state.associatedMachineId,
  });

  handleSiteReassignSuccess = () => {
    // Refresh the list and close the panel; the device is no longer in it (else it hangs on a spinner).
    this.props.sensorsActions.getSensorsList();
    this.props.close();
  };

  componentDidMount() {
    const { getResourcesBasedOnType } = this.props.sensorsActions;
    if (this.state.options.machine.length === 0) {
      getResourcesBasedOnType('area');
      getResourcesBasedOnType('machine').then(
        res =>
          this.setState(prevState => ({
            options: {
              ...prevState.options,
              machine: res
            }
          })),
        error => this.setState({ error })
      );
    }
    const {
      details,
      sensor: { model, serial_number }
    } = this.props;
    let sensor = {};
    if (details[model]) sensor = details[model].find(d => d.serial_number === serial_number);
    if (sensor) {
      const merged = _.cloneDeep(sensor);
      if (merged.account_id == null) {
        merged.account_id = this.props.sensor.account_id != null
          ? this.props.sensor.account_id
          : (this.props.currentAccount && this.props.currentAccount.id);
      }
      this.setState({
        details: merged,
        associatedMachineId: sensor.machine
      }, () => {
        this.savedReferenceDetail = _.cloneDeep(merged);
        this.enableSave(sensor);
      });
    }

    // Fetch event configuration metadata for event-detection-capable motes
    if (['VM4', 'VM4P', 'GS', 'GSP', 'VM4P-IS'].includes(model)) {
      this.props.eventConfigActions.getEventConfigMetadata();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      details,
      sensor: { model, serial_number }
    } = this.props;
    const {
      details: prevDetails,
      sensor: { model: prevModel, serial_number: prevSerialNumber }
    } = prevProps;
    const {
      getLocationOptions,
      getComponentOptions
    } = this.props.sensorsActions;
    let sensor = {};
    let prevSensor = {};
    if (details[model]) {
      sensor = details[model].find(d => d.serial_number === serial_number);
    }
    if (prevDetails[prevModel]) {
      prevSensor = prevDetails[prevModel].find(
        d => d.serial_number === prevSerialNumber
      );
    }
    let syncedDetailsFromProps = false;
    if (
      sensor &&
      (!_.isEqual(prevSensor, sensor) ||
        prevState.details.serial_number !== sensor.serial_number ||
        !_.isEqual(
          prevState.options.machine.length,
          this.state.options.machine.length
        ))
    ) {
      syncedDetailsFromProps = true;
      if (
        this.props.createdMachineId &&
        !_.isEmpty(this.state.options.machine)
      ) {
        const clonedDetails = _.cloneDeep(sensor);
        clonedDetails.machine = this.props.createdMachineId;
        const obj = this.state.options.machine.find(
          e => e.value === this.props.createdMachineId
        );
        clonedDetails.machine_name = (obj && obj.text) || '';
        if (clonedDetails.account_id == null) {
          clonedDetails.account_id = this.props.sensor.account_id != null
            ? this.props.sensor.account_id
            : (this.props.currentAccount && this.props.currentAccount.id);
        }
        this.setState({
          details: clonedDetails,
          associatedMachineId: this.props.createdMachineId
        }, () => {
          this.savedReferenceDetail = _.cloneDeep(clonedDetails);
          this.enableSave(sensor);
        });
      } else {
        const mergedDetails = _.cloneDeep(sensor);
        if (mergedDetails.account_id == null) {
          mergedDetails.account_id = this.props.sensor.account_id != null
            ? this.props.sensor.account_id
            : (this.props.currentAccount && this.props.currentAccount.id);
        }
        this.setState({
          details: mergedDetails,
          associatedMachineId: sensor.machine
        }, () => {
          this.savedReferenceDetail = _.cloneDeep(mergedDetails);
          this.enableSave(sensor);
        });
      }
      if (
        !['VM1', 'VM2'].includes(sensor.model) &&
        sensor.full_bandwidth &&
        sensor.high_res &&
        this.isScheduleAggressive(sensor) &&
        this.props.metadata[model].reporting &&
        this.props.metadata[model].reporting.max_measurement_count
      ) {
        const schedule = [
          sensor.full_bandwidth.schedule,
          sensor.high_res.schedule
        ];
        const maxReportingInterval = sensorUtils.calculateMaxReportingInterval(
          schedule,
          this.props.metadata[model].reporting.max_measurement_count
        );
        this.setState({
          maxReportingInterval
        });
      }
    }
    if (
      this.state.details.machine &&
      !this.state.loading.components &&
      (_.isEmpty(this.state.options.component) ||
        prevState.details.machine !== this.state.details.machine)
    ) {
      this.setState(prevState => ({
        loading: {
          ...prevState.loading,
          components: true
        }
      }));
      getComponentOptions(Number(this.state.details.machine)).then(
        (res) => {
          this.setState(prevState => ({
            options: {
              ...prevState.options,
              component: res
            },
            loading: {
              ...prevState.loading,
              components: false
            }
          }));
        },
        error => this.setState({ error })
      );
    }
    if (
      this.state.details.machine &&
      !this.state.loading.locations &&
      (prevState.details.machine !== this.state.details.machine ||
        prevState.details.component !== this.state.details.component)
    ) {
      this.setState(prevState => ({
        loading: {
          ...prevState.loading,
          locations: true
        }
      }));
      getLocationOptions(
        Number(this.state.details.machine),
        Number(this.state.details.component)
      ).then((res) => {
        this.setState(prevState => ({
          options: {
            ...prevState.options,
            location: res
          },
          loading: {
            ...prevState.loading,
            locations: false
          }
        }));
      });
    }
    if (prevState.editMode !== this.props.editMode) {
      this.setState({
        editMode: this.props.editMode
      });
    }
    if (sensor && sensor.config_wifi_ssid !== (prevSensor && prevSensor.config_wifi_ssid)) {
      this.setState({ ssid: sensor.config_wifi_ssid });
    }
    if (sensor && sensor.config_wifi_passphrase !== (prevSensor && prevSensor.config_wifi_passphrase)) {
      this.setState({ passphrase: sensor.config_wifi_passphrase });
    }
    if (sensor && sensor.config_wifi_start_time !== (prevSensor && prevSensor.config_wifi_start_time)) {
      this.setState(getWifiScheduleState(sensor.config_wifi_start_time));
    }
    if (sensor && sensor.ap_bssid !== (prevSensor && prevSensor.ap_bssid)) {
      this.setState({ bssid: sensor.ap_bssid });
    }
    if (sensor && sensor.ap_channel !== (prevSensor && prevSensor.ap_channel)) {
      this.setState({ channel: sensor.ap_channel });
    }
    if (!sensor) return;
    if (!syncedDetailsFromProps) {
      this.enableSave(sensor);
    }
  }

  getPropsSensor = () => {
    const { details, sensor: { model, serial_number } } = this.props;
    if (!details[model]) return null;
    return details[model].find(d => d.serial_number === serial_number) || null;
  };

  normalizeEmptyValue = (value) => {
    if (value === undefined || value === null || value === '') {
      return null;
    }
    return value;
  };

  normalizeDetailForComparison = (detail) => {
    if (!detail) return {};
    const normalized = _.cloneDeep(detail);
    [
      'machine',
      'machine_name',
      'location',
      'location_name',
      'component',
      'component_name'
    ].forEach((key) => {
      normalized[key] = this.normalizeEmptyValue(normalized[key]);
    });
    normalized.temperature_only = Boolean(normalized.temperature_only);
    // Backoff is on unless explicitly turned off, so a row that predates the
    // field must not read as a pending change.
    normalized.wifi_backoff = normalized.wifi_backoff !== false;
    normalized.aggressive_measurement = Boolean(normalized.aggressive_measurement);
    normalized.debug_mode = Boolean(normalized.debug_mode);
    return normalized;
  };

  hasUnsavedChanges = (referenceSensor) => {
    const { details, ssid, passphrase, bssid, channel } = this.state;
    if (!referenceSensor) return false;

    const normalizedState = this.normalizeDetailForComparison(details);
    const normalizedReference = this.normalizeDetailForComparison(referenceSensor);

    const stateWithoutEventDetection = { ...normalizedState };
    const referenceWithoutEventDetection = { ...normalizedReference };
    delete stateWithoutEventDetection.event_detection;
    delete referenceWithoutEventDetection.event_detection;

    const hasMainDetailsChanges = !_.isEqual(
      stateWithoutEventDetection,
      referenceWithoutEventDetection
    );

    const refChannel = referenceSensor.ap_channel;
    const hasWifiChanges = (
      (!_.isEmpty(ssid) && ssid !== referenceSensor.config_wifi_ssid) ||
      (!_.isEmpty(passphrase) && passphrase !== referenceSensor.config_wifi_passphrase) ||
      isWifiConfigChanged(this.state, referenceSensor) ||
      (!_.isEmpty(bssid) && bssid !== referenceSensor.ap_bssid) ||
      (channel != null && channel !== '' && String(channel) !== String(refChannel != null ? refChannel : ''))
    );

    const stateEventDetection = normalizedState.event_detection || { event_configs: [], enabled: false };
    const referenceEventDetection = normalizedReference.event_detection || { event_configs: [], enabled: false };
    const hasEventDetectionChanges = !areEventDetectionsEqual(stateEventDetection, referenceEventDetection);

    return hasMainDetailsChanges || hasWifiChanges || hasEventDetectionChanges;
  };

  enableSave = (sensor) => {
    const { errorMessages, saveEnabled, eventDetectionValidationValid } = this.state;
    const { updateFooter } = this.props;
    const referenceSensor = this.savedReferenceDetail || sensor;

    const setSaveState = (enabled) => {
      if (saveEnabled !== enabled) {
        this.setState({ saveEnabled: enabled });
        if (updateFooter) updateFooter(enabled);
      }
    };

    if (!referenceSensor) {
      setSaveState(false);
      return;
    }

    if (!_.isEmpty(errorMessages) || !eventDetectionValidationValid) {
      setSaveState(false);
      return;
    }

    setSaveState(this.hasUnsavedChanges(referenceSensor));
  };

  dissociateSensor = () => {
    this.setState(
      prevState => ({
        details: {
          ...prevState.details,
          location: null,
          location_name: null,
          machine: null,
          machine_name: null,
          component: null,
          component_name: null
        },
        associatedMachineId: null
      }),
      () => this.onSave()
    );
  };

  filterReportingIntervals = () => {
    const { details } = this.state;
    const ri_upper_threshold = sensorUtils.getVersionThreshold(details.firmware_versions.mcu);

    const threshold =
      this.state.maxReportingInterval || AGGRESSIVE_INTERVAL_THRESHOLD;

    const { metadata } = this.props;
    if (this.isScheduleAggressive(details)) {
      return _.filter(
        metadata[details.model].reporting.interval,
        o => o.value <= threshold
      );
    }
    return _.filter(
      metadata[details.model].reporting.interval,
      o => o.value > AGGRESSIVE_INTERVAL_THRESHOLD && o.value <= ri_upper_threshold
    );
  };

  isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  stringifyOptions = options =>
    options.map(option => ({
      ...option,
      value: _.isObject(option.value)
        ? JSON.stringify(option.value)
        : option.value
    }));

  mapOptionsText = options =>
    options.map((option) => {
      const { t } = this.props;
      const next = { ...option };
      if (next.text === 'HAV') {
        next.text = t('sensors.orientation.vertical');
      } else if (next.text === 'VAH') {
        next.text = t('sensors.orientation.horizontal');
      } else if (next.text === 'HVA') {
        next.text = t('sensors.orientation.axial');
      }
      return next;
    });

  // Shared by the accelerometer (g) and magnetometer (gauss) ranges; only the list and label differ.
  renderRangeField = (ranges, translateLabel, type, label, value, disabled, name, search) => {
    const { t, updating } = this.props;
    const { editMode } = this.state;
    const rangeOptions = {};
    ranges.forEach((range) => {
      rangeOptions[range] = translateLabel(t, range);
    });
    if (editMode) {
      return (
        <ResourceInputField
          type={type}
          label={label}
          options={ranges.map(range => ({ value: range, text: rangeOptions[range] }))}
          value={value}
          name={name}
          key={name}
          disabled={disabled || updating}
          onChange={(e, changed) => this.onChangeField(e, changed, name)}
          selectOnBlur={false}
          search={search}
        />
      );
    }
    return (
      <Fragment>
        <ResourceItemLabel>{label}</ResourceItemLabel>
        <ResourceItem>{rangeOptions[value] || '--'}</ResourceItem>
      </Fragment>
    );
  };

  renderField = (
    type,
    label,
    options_T,
    value_T,
    disabled,
    name,
    search = false,
    showReportingInfo = false
  ) => {
    const { t } = this.props;
    const { editMode } = this.state;
    const { updating } = this.props;
    let options = this.stringifyOptions(options_T);
    if (name === 'orientation') {
      options = this.mapOptionsText(options);
    } else {
      options = translateSensorSelectOptions(t, name, options);
    }
    const value = _.isObject(value_T) ? JSON.stringify(value_T) : value_T;
    if (name === 'reporting_interval' && showReportingInfo) {
      const { details } = this.state;
      const { utcOffset } = this.props;
      const reportingTimeInfo = sensorUtils.getReportingTimeInfo(
        details.reporting_start_time,
        details.reporting_interval,
        utcOffset
      );
      const reportingPopupContent = reportingTimeInfo ? (
        <span>
          {t('sensors.reportingInfo.startsAt', 'This device starts reporting at')}{' '}
          <strong>
            {reportingTimeInfo.localDay} {reportingTimeInfo.localTime}
          </strong>{' '}
          ({reportingTimeInfo.utcTime} UTC
          {reportingTimeInfo.recurrence ? `, ${reportingTimeInfo.recurrence}` : ''}).
          <ReportingExplainer>
            {t(
              'sensors.reportingInfo.explanation',
              'Reporting start times are staggered across accounts to spread reporting load on the cloud, and are anchored shortly after the full-bandwidth measurement so reports carry fresh data.'
            )}
          </ReportingExplainer>
        </span>
      ) : (
        <span>
          {t(
            'sensors.reportingInfo.notAvailable',
            'The reporting time has not been computed for this device yet. It is derived from the full-bandwidth measurement schedule.'
          )}
        </span>
      );
      const reportingInfoLabel = (
        <ResourceItemLabel>
          {label}
          <Popup
            position="top center"
            wide
            content={reportingPopupContent}
            trigger={(
              <span style={{ cursor: 'pointer' }}>
                <Info aria-hidden="true" size="1x" style={{ marginLeft: '5px' }} />
              </span>
            )}
          />
        </ResourceItemLabel>
      );
      if (editMode) {
        return (
          <Fragment>
            {reportingInfoLabel}
            <ResourceInputField
              paddingtop="0"
              type={type}
              options={options}
              value={value}
              name={name}
              key={name}
              disabled={disabled || updating}
              onChange={(e, val) => this.onChangeField(e, val, name)}
              selectOnBlur={false}
              search={search}
            />
          </Fragment>
        );
      }
      let reportingTextValue = '--';
      if (options) {
        const element = options.filter(option =>
          _.isEqual(option.value, value)
        )[0];
        if (element) reportingTextValue = element.text;
      }
      return (
        <Fragment>
          {reportingInfoLabel}
          <ResourceItem>{reportingTextValue}</ResourceItem>
        </Fragment>
      );
    }
    if (name === 'fs_range') {
      return this.renderRangeField(ACCELEROMETER_FS_RANGES, translateFsRangeLabel, type, label, value, disabled, name, search);
    }
    if (name === 'magnetometer_fs_range') {
      return this.renderRangeField(
        MAGNETOMETER_FS_RANGES, translateMagnetometerFsRangeLabel, type, label, value, disabled, name, search
      );
    }
    if (name === 'orientation') {
      options = this.mapOptionsText(options);
      if (editMode) {
        return (
          <Fragment>
            <ResourceItemLabel>
              {t('sensors.detail.orientation')}
              <span onClick={() => this.setState({ openMoteOrentation: true })}>
                <Info
                  aria-hidden="true"
                  size="1x"
                  style={{ marginLeft: '5px' }}
                />
              </span>
            </ResourceItemLabel>
            <ResourceInputField
              paddingtop="0"
              type={type}
              options={options}
              value={value}
              name={name}
              key={name}
              disabled={disabled || updating}
              onChange={(e, value) => this.onChangeField(e, value, name)}
              selectOnBlur={false}
              search={search}
            />
          </Fragment>
        );
      }
      let textValue = '';
      if (options) {
        const element = options.filter(option =>
          _.isEqual(option.value, value)
        )[0];
        if (element) textValue = element.text;
        else textValue = '--';
      }
      return (
        <Fragment>
          <ResourceItemLabel>
            {t('sensors.detail.orientation')}
            <span onClick={() => this.setState({ openMoteOrentation: true })}>
              <Info
                aria-hidden="true"
                size="1x"
                style={{ marginLeft: '5px' }}
              />
            </span>
          </ResourceItemLabel>
          <ResourceItem>{textValue}</ResourceItem>
        </Fragment>
      );
    }
    if (editMode) {
      return (
        <ResourceInputField
          type={type}
          label={label}
          options={options}
          value={value}
          name={name}
          key={name}
          disabled={disabled || updating}
          onChange={(e, value) => this.onChangeField(e, value, name)}
          selectOnBlur={false}
          search={search}
        />
      );
    }
    let textValue = '';
    if (options) {
      const element = options.filter(option =>
        _.isEqual(option.value, value)
      )[0];
      if (element) textValue = element.text;
      else textValue = '--';
    }
    return (
      <Fragment>
        <ResourceItemLabel>{label}</ResourceItemLabel>
        {name === 'machine' ? (
          <ResourceItem
            onClick={() => this.redirectToMachine(value)}
            hover={textValue !== '--'}
          >
            {textValue}
          </ResourceItem>
        ) : (
          <ResourceItem>{textValue}</ResourceItem>
        )}
      </Fragment>
    );
  };

  handleInputClick = (e, data) => {
    const targetValue = e.target.value || data.value || '';
    const targetName = e.target.name || data.name;

    this.setState({ [targetName]: targetValue }, this.validateInput);
  };

  // Backend sends null when the device has no settable magnetometer range.
  showsMagnetometerFsRange = details => (
    details.magnetometer_fs_range !== null &&
    details.magnetometer_fs_range !== undefined &&
    !details.temperature_only
  );

  onChangeField = (e, { value }, name) => {
    const { details } = this.state;
    if (name === 'fs_range' || name === 'magnetometer_fs_range') {
      const updatedDetails = { ...details, [name]: value };
      this.setState({ details: updatedDetails });
      return null;
    }
    if (name === 'machine' || name === 'component' || name === 'location') {
      const key = `${name}_name`;
      const text = this.state.options[name].find(e => e.value === value).text;
      const updatedDetails = update(details, {
        [key]: { $set: text },
        [name]: { $set: this.isJson(value) ? JSON.parse(value) : value }
      });
      this.setState({ details: updatedDetails });
      return null;
    }
    const [newName, option] = name.split('.');
    if (option) {
      let key = option;
      let val = value;
      if (key === 'state_based_schedule') {
        key = 'schedule';
        val = [{ start: ['0', '00:00'], end: null, interval: value }];
      }
      const updatedDetails = update(details, {
        [newName]: { [key]: { $set: this.isJson(val) ? JSON.parse(val) : val } }
      });
      this.setState({ details: updatedDetails });
      return null;
    }
    if (name === 'measurement_settings_type') {
      const defaultSchedule = [
        { start: ['0', '00:00'], end: null, interval: 10800 }
      ];
      const stops = [];
      // Only full bandwidth gets a seeded schedule when switching to state based.
      const updatedDetails = update(details, this.presentBlocksSpec(index => ({
        type: { $set: value },
        schedule: {
          $set: index === vibrationMeasurementTypeEnum.fullBandwidth && value === 'state_based'
            ? defaultSchedule
            : []
        },
        stops: { $set: stops }
      })));
      this.setState({ details: updatedDetails });
      return null;
    }
    const updatedDetails = update(details, {
      [name]: { $set: this.isJson(value) ? JSON.parse(value) : value }
    });
    this.setState({ details: updatedDetails });
    return null;
  };

  isScheduleChanged = (newDetails, oldDetails) =>
    _.some(
      aggressive_measurement_types,
      mt =>
        !_.isEqual(
          newDetails[mt] && newDetails[mt].schedule,
          oldDetails[mt] && oldDetails[mt].schedule
        )
    );

  /**
   * Builds an immutability-helper spec covering only the measurement blocks this
   * device actually reports.
   *
   * immutability-helper throws the moment a nested spec descends into a key
   * whose value is undefined, and a model only carries the measurement types it
   * supports — so every block has to be probed before it is described. Callers
   * supply the per-block spec and receive the payload index ('0'/'1'/'2') so
   * they can pull the matching entry out of index-keyed data.
   */
  presentBlocksSpec = specForIndex =>
    vibrationMeasurementBlocks.reduce(
      (spec, { index, field }) => (
        this.state.details[field]
          ? { ...spec, [field]: specForIndex(index, field) }
          : spec
      ),
      {}
    );

  // Guarded the same way as isScheduleChanged above: models that report fewer
  // measurement blocks (temperature-only and some VSX variants) carry no
  // full_bandwidth or high_res at all. `_.some` copes with an undefined
  // collection, but `details[mt].schedule` throws before it ever gets there.
  isScheduleAggressive = details =>
    _.some(aggressive_measurement_types, mt =>
      _.some(
        details[mt] && details[mt].schedule,
        s => s.interval <= AGGRESSIVE_INTERVAL_THRESHOLD
      )
    );

  onClickCheckAggressive = () => {
    const { details: newDetails } = this.state;
    const { details: oldDetails } = this.props;
    if (
      ['VM3', 'VM4', 'VM4P', 'GS', 'GSP', 'VM4P-IS'].includes(newDetails.model) &&
      newDetails.overall.type === 'state_based' &&
      this.isScheduleChanged(newDetails, oldDetails[newDetails.model][0]) &&
      this.isScheduleAggressive(newDetails)
    ) {
      this.setState({ aggressiveModal: true });
    } else {
      this.onSave();
    }
  };

  closeAggressiveModal = () => {
    this.setState({ aggressiveModal: false });
  };

  validateInput = () => {
    const { ssid, passphrase, bssid, channel, wifi_schedule_date, wifi_schedule_time } = this.state;
    const errorMessages = {};
    if (ssid || passphrase) {
      if (!passphrase) errorMessages.passphrase_error = ErrorMessages.wifi_password_required;
      if (!ssid) errorMessages.ssid_error = ErrorMessages.wifi_ssid_required;
    }
    if (
      isWifiConfigChanged(this.state, this.savedReferenceDetail || this.getPropsSensor()) &&
      isWifiScheduleInPast(wifi_schedule_date, wifi_schedule_time)
    ) {
      errorMessages.wifi_schedule_error = ErrorMessages.wifi_schedule_in_past;
    }
    if (!_.isEmpty(bssid)) {
      if (!bssid.match(/^([A-Fa-f0-9]{12})$/)) {
        errorMessages.bssid_error = ErrorMessages.invalid_bssid;
      }
    }
    const channelInt = parseInt(channel, 10);
    if (_.isNumber(channelInt) && (channelInt < 1 || channelInt > 13)) {
      errorMessages.channel_error = ErrorMessages.invalid_channel;
    }
    this.setState({ errorMessages });
  };

  onSave = () => {
    const { updateSensorDetails } = this.props.sensorsActions;
    const {
      details: {
        serial_number,
        model,
        orientation,
        overall,
        full_bandwidth,
        high_res,
        location,
        location_name,
        machine,
        machine_name,
        component,
        component_name,
        reporting_interval,
        aggressive_measurement_timeout,
        fs_range,
        magnetometer_fs_range,
        temperature_only,
        wifi_backoff,
        event_detection
      },
      ssid,
      passphrase,
      wifi_schedule_date,
      wifi_schedule_time,
      bssid,
      channel
    } = this.state;
    const propsDetails = this.props.details[this.props.sensor.model].find(
      d => d.serial_number === this.props.sensor.serial_number
    );
    const start_time = sensorUtils.getEpochFromDateTime(
      wifi_schedule_date,
      wifi_schedule_time
    );
    const data = {
      [model]: {
        serial_number: [serial_number],
        fs_range,
        magnetometer_fs_range,
        orientation,
        measurement_settings: {
          0: overall,
          1: full_bandwidth,
          2: high_res
        },
        reporting: {
          interval: reporting_interval
        },
        location_id: location,
        location_name,
        component,
        component_name,
        machine,
        machine_name,
        type: 'Vibration Mote',
        force_association: this.state.force_association,
        aggressive_measurement: this.isScheduleAggressive(this.state.details),
        aggressive_measurement_timeout,
        temperature_only,
      }
    };
    // Petasense-admin-only field; the API 403s the whole request if anyone
    // else sends it, so keep it out of the payload entirely.
    if (isPetasenseAdmin(this.props.user) && WIFI_BACKOFF_MODELS.includes(model)) {
      data[model].wifi_backoff = wifi_backoff !== false;
    }

    // Add event detection configs if they exist and the model supports it
    // Only send event_configs if the mote has a measurement location
    if (['VM4', 'VM4P', 'GS', 'GSP', 'VM4P-IS'].includes(model) && event_detection && location) {
      // Check if temperature_only is changing from False to True
      const previousTemperatureOnly = propsDetails.temperature_only || false;
      const newTemperatureOnly = temperature_only || false;
      const temperatureOnlyChanging = !previousTemperatureOnly && newTemperatureOnly;

      // Filter out non-temperature configs if temperature_only is changing from False to True
      let configsToSave = event_detection.event_configs || [];
      if (temperatureOnlyChanging && configsToSave.length > 0) {
        configsToSave = configsToSave.filter((config) => {
          if (!config || !config.conditions) return false;
          // Keep only configs where all conditions are temperature-based
          return config.conditions.every(condition => condition.metric === 'Temperature');
        });

        // Show warning if configs were filtered
        if (configsToSave.length < (event_detection.event_configs || []).length) {
          toastr.warning(this.props.t('sensors.messages.temperatureOnlyNonTempRemoved', {
            defaultValue: 'Non-temperature event detection configurations were removed because temperature-only mode was enabled.'
          }));
        }
      }
      // Transform UI format to device format
      const deviceFormatConfigs = toDeviceFormat(
        configsToSave,
        this.props.eventMetadata
      );
      data[model].event_configs = deviceFormatConfigs;
      data[model].event_detection_enabled = event_detection.enabled || false;
    }

    if (isWifiConfigChanged(this.state, this.savedReferenceDetail || propsDetails)) {
      data[model].wifi_config = {
        ssid,
        passphrase,
        start_time
      };
    }

    // Initialize wifi_ap_config
    data[model].wifi_ap_config = {};

    // Add bssid if it exists
    if (bssid && bssid.trim() !== '') {
      data[model].wifi_ap_config.bssid = bssid;
    }

    // Add channel if it exists and is valid
    if (channel !== null && channel !== undefined && channel !== '') {
      const channelInt = parseInt(channel, 10);
      if (!Number.isNaN(channelInt)) {
        data[model].wifi_ap_config.channel = channelInt;
      }
    }

    if (_.isEqual(orientation, propsDetails.orientation)) delete data[model].orientation;
    if (_.isEqual(location, propsDetails.location)) delete data[model].location_id;
    if (this.state.details.debug_mode) data[model] = stripDebugModeKeys(data[model]);
    updateSensorDetails(data).then(
      (updatedDetails) => {
        const { serial_number, model } = this.props.sensor;
        if (this.state.force_association) {
          this.setState({ force_association: false });
        }
        if (this.state.aggressiveModal) {
          this.closeAggressiveModal();
        }
        // Refetch canonical row shape (event_detection, wifi fields) after PUT;
        // fall back to PUT response or props if GET fails so save still completes cleanly.
        return this.props.sensorsActions.fetchSensorDetailRowForTransfer(serial_number)
          .catch(() => {
            const fromPut = updatedDetails && updatedDetails[model]
              ? updatedDetails[model].find(d => d.serial_number === serial_number)
              : null;
            return fromPut || this.getPropsSensor();
          });
      },
      (error) => {
        if (error && error.mote_exists) {
          this.setState({
            force_association: true,
            force_association_msg: error.message
          });
        } else {
          toastr.error(error.message);
        }
      }
    ).then(
      (savedSensor) => {
        if (savedSensor) {
          this.syncDetailsAfterSave(savedSensor);
        }
      }
    );
  };

  onCancel = () => {
    const {
      details,
      sensor: { model, serial_number }
    } = this.props;
    let sensor = {};
    if (details[model]) {
      sensor = details[model].find(d => d.serial_number === serial_number);
    }
    if (sensor && !_.isEqual(this.state.details, sensor)) {
      const resetDetails = _.cloneDeep(sensor);
      this.setState({
        details: resetDetails
      }, () => {
        this.savedReferenceDetail = _.cloneDeep(resetDetails);
        this.enableSave(sensor);
      });
    }
    if (sensor) {
      this.setState({
        ssid: sensor.config_wifi_ssid || '',
        passphrase: sensor.config_wifi_passphrase || '',
        ...getWifiScheduleState(sensor.config_wifi_start_time)
      }, this.validateInput);
    }
    if (this.state.force_association) this.setState({ force_association: false });
  };

  saveSchedule = (schedule, stops, maxReportingInterval) => {
    const { details } = this.state;
    const updatedDetails = update(details, this.presentBlocksSpec(index => ({
      schedule: { $set: schedule[index] },
      stops: { $set: stops[index] }
    })));
    this.setState(
      { details: updatedDetails, openScheduler: false, maxReportingInterval },
      () => this.onSave()
    );
  };

  redirectToMachine = (machineId) => {
    if (machineId) {
      history.push(`/machines/${machineId}/overview`);
    }
  };

  closeModal = () => {
    this.setState({ force_association: false });
  };

  getDownloadUrl = (mote_id) => {
    const url = `${getBaseUrl()}/i/v1/motes/${mote_id}/download-logs?output=csv`;
    return url;
  };

  getConfigs = (serial_number) => {
    const url = `${getBaseUrl()}/i/v2/sensors/${serial_number}/config`;
    return url;
  }

  getConfigHistories = (serial_number) => {
    const url = `${getBaseUrl()}/i/v2/sensors/${serial_number}/config-history`;
    return url;
  }

  getImpUrl = (device_id) => {
    const url = `https://impcentral.electricimp.com/ide/devices/${device_id}`;
    return url;
  }

  handleLogAnalysisClick = () => {
    this.setState(prevState => ({
      logAnalysisKey: prevState.logAnalysisKey + 1
    }));
    this.setState({ showLogAnalysisModal: true });
  };

  handleLastReportedClick = () => {
    this.setState(prevState => ({
      lastReportedKey: prevState.lastReportedKey + 1
    }));
    this.setState({ showLastReportedModal: true });
  };

  calculateDaysDifference = (targetDateStr) => {
    const targetDate = new Date(targetDateStr);
    const currentDate = new Date();
    const timeDifferenceMs = targetDate - currentDate;
    const daysDifference = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
    return Math.abs(daysDifference);
  }

  clearAPSettings = () => {
    this.setState({ bssid: '', channel: '' }, this.onSave);
  }

  syncDetailsAfterSave = (savedSensor) => {
    const { sensor, currentAccount, updateFooter } = this.props;

    if (!savedSensor) {
      this.setState({ saveEnabled: false }, () => {
        if (updateFooter) updateFooter(false);
      });
      return;
    }

    const mergedDetails = _.cloneDeep(savedSensor);
    if (mergedDetails.account_id == null && sensor) {
      mergedDetails.account_id = sensor.account_id != null
        ? sensor.account_id
        : (currentAccount && currentAccount.id);
    }

    this.setState({
      details: mergedDetails,
      associatedMachineId: savedSensor.machine,
      ssid: savedSensor.config_wifi_ssid || '',
      passphrase: savedSensor.config_wifi_passphrase || '',
      ...getWifiScheduleState(savedSensor.config_wifi_start_time),
      bssid: savedSensor.ap_bssid || '',
      channel: savedSensor.ap_channel != null ? savedSensor.ap_channel : null,
      saveEnabled: false
    }, () => {
      this.savedReferenceDetail = _.cloneDeep(mergedDetails);
      if (updateFooter) updateFooter(false);
    });
  };

  handleEventDetectionChange = (eventDetection) => {
    const { details } = this.state;
    const updatedDetails = update(details, {
      event_detection: { $set: eventDetection }
    });
    this.setState({ details: updatedDetails });
  };

  handleEventDetectionValidationChange = (isValid) => {
    this.setState({ eventDetectionValidationValid: isValid }, () => {
      this.enableSave(this.getPropsSensor());
    });
  };


  renderAggressiveModal = (maxReportingInterval = null) => {
    const { metadata, t } = this.props;
    const { details } = this.state;
    const threshold = maxReportingInterval || AGGRESSIVE_INTERVAL_THRESHOLD;
    return (
      <div>
        {' '}
        {this.renderField(
          'select',
          t('sensors.aggressiveMeasurement.measurementTimeOutInterval'),
          metadata.aggressive_measurement_timeout.interval,
          details.aggressive_measurement_timeout,
          false,
          'aggressive_measurement_timeout'
        )}
        {metadata[details.model].reporting &&
          metadata[details.model].reporting.interval &&
          this.renderField(
            'select',
            t('sensors.detail.reportingInterval'),
            _.filter(
              metadata[details.model].reporting.interval,
              o => o.value <= threshold
            ),
            details.reporting_interval,
            false,
            'reporting_interval'
          )}
      </div>
    );
  };

  renderReportingIntervalModal = () => {
    const { metadata, t } = this.props;
    const { details } = this.state;

    const version_threshold = sensorUtils.getVersionThreshold(details.firmware_versions.mcu);
    return (
      <div>
        {metadata[details.model].reporting &&
          metadata[details.model].reporting.interval &&
          this.renderField(
            'select',
            t('sensors.detail.reportingInterval'),
            _.filter(
              metadata[details.model].reporting.interval,
              o => o.value > AGGRESSIVE_INTERVAL_THRESHOLD && o.value <= version_threshold
            ),
            details.reporting_interval,
            false,
            'reporting_interval'
          )}
      </div>
    );
  };

  handleTemperatureOnlyToggle = () => {
    const { details } = this.state;
    const updatedDetails = {
      ...details,
      temperature_only: !details.temperature_only
    };
    this.setState({ details: updatedDetails });
  };

  handleWifiBackoffToggle = () => {
    const { details } = this.state;
    const updatedDetails = {
      ...details,
      wifi_backoff: details.wifi_backoff === false
    };
    this.setState({ details: updatedDetails });
  };

  getToggleTitle = () => {
    const { details } = this.state;
    if (details.location) {
      return ErrorMessages.temperature_only_location_assigned;
    }
    return details.temperature_only
      ? this.props.t('sensors.temperatureOnly.disable')
      : this.props.t('sensors.temperatureOnly.enable');
  };

  render() {
    const {
      aggressiveModal,
      details,
      saveEnabled,
      error,
      ssid,
      passphrase,
      errorMessages,
      wifi_schedule_date,
      wifi_schedule_time,
      showLogAnalysisModal,
      showLastReportedModal,
      bssid,
      channel
    } = this.state;
    const {
      metadata,
      loading,
      detailsError,
      errorList,
      updating,
      utcOffset,
      user,
      primaryColor,
      t
    } = this.props;
    const disableReportingProceed =
    ['VM3', 'VM4', 'VM4P', 'GS', 'GSP', 'VM4P-IS'].includes(details.model) &&
      details.reporting_interval < AGGRESSIVE_INTERVAL_THRESHOLD;
    // While debug mode is active the backend rejects schedule/reporting/sampling
    // edits (they'd clobber the debug config), so disable those controls here.
    const debugActive = details.debug_mode;
    if (!loading && details.model && (!metadata || !metadata[details.model])) {
      return t('sensors.errors.metadataMissing', { model: details.model });
    }
    if (!details.model || !details.overall) {
      return (
        <AbsoluteLoading nobackground>
          <LoadingSvg />
        </AbsoluteLoading>
      );
    }
    // `overall` is guaranteed by the guard above, but the other two blocks are
    // not: models that report fewer measurement_settings entries carry no
    // high_res / full_bandwidth at all (see getSensorDetails). Being gated on
    // `!temperature_only` is not enough — a device can be neither
    // temperature-only nor carry these blocks. Falling back to an empty object
    // lets the fields below resolve to the usual "--" instead of throwing.
    const highRes = details.high_res || {};
    const fullBandwidth = details.full_bandwidth || {};
    return (
      <Fragment>
        {updating && (
          <AbsoluteLoading>
            <LoadingSvg />
          </AbsoluteLoading>
        )}
        {aggressiveModal && (
          <AggressiveMeasurementAlertPrompt
            message={t('sensors.aggressiveMeasurement.message')}
            secondaryMessage={t('sensors.aggressiveMeasurement.secondaryMessage')}
            onCancel={this.closeAggressiveModal}
            onProceed={this.onSave}
            component={this.renderAggressiveModal()}
          />
        )}
        {this.state.force_association && (
          <Modal width="70%" padding="0" close={this.closeModal}>
            <FlexContainer direction="column" alignItems="center">
              <H4>{this.state.force_association_msg}</H4>
              <FlexContainer>
                <Button
                  style={{ margin: '10px' }}
                  bordercolor={this.props.theme.colors.red}
                  secondary={this.props.theme.colors.red}
                  onClick={this.onSave}
                >
                  {t('sensors.aggressiveMeasurement.proceed')}
                </Button>
                <Button
                  style={{ margin: '10px' }}
                  bordercolor={this.props.theme.colors.black}
                  secondary={this.props.theme.colors.black}
                  onClick={this.onCancel}
                >
                  {t('common.cancel')}
                </Button>
              </FlexContainer>
            </FlexContainer>
          </Modal>
        )}
        {this.state.openMoteOrentation && (
          <MoteOrientationGuide
            close={() => this.setState({ openMoteOrentation: false })}
          />
        )}
        {this.state.openScheduler && (
          <MeasurementScheduleModal
            close={() => this.setState({ openScheduler: false })}
            editMode={this.state.editMode}
            schedule={{
              // Same missing-block story as isScheduleAggressive: a device that
              // reports no full_bandwidth/high_res would otherwise reach the
              // modal's `value.map(...)` as undefined and throw the moment the
              // "View" schedule link is opened. Empty arrays match the modal's
              // own internal defaults, so present data behaves identically.
              0: details.overall.schedule || [],
              1: fullBandwidth.schedule || [],
              2: highRes.schedule || []
            }}
            stops={{
              0: details.overall.stops || [],
              1: fullBandwidth.stops || [],
              2: highRes.stops || []
            }}
            disabledRows={{
              // A block the device does not report cannot be saved —
              // saveSchedule deliberately leaves it out of the update spec — so
              // its row is disabled rather than editable. Left enabled, the user
              // could draw a schedule against it and have it silently discarded.
              0: false,
              1: !details.full_bandwidth,
              2: !details.high_res
            }}
            intervals={metadata[details.model].measurement_settings.intervals}
            saveSchedule={this.saveSchedule}
            utcOffset={utcOffset}
            type="Vibration Mote"
            temperatureOnly={details.temperature_only}
            reportingIntervalComponent={
              ['VM1', 'VM2'].includes(details.model)
                ? null
                : this.renderReportingIntervalModal()
            }
            component={(maxReportingInterval = null) =>
              this.renderAggressiveModal(maxReportingInterval)
            }
            onProceedDisabledReporting={disableReportingProceed}
            maxMeasurementCount={
              metadata[details.model].reporting
                ? metadata[details.model].reporting.max_measurement_count
                : null
            }
            restrictHighRes
          />
        )}
        <Container>
          {loading && !detailsError && !error && (
            <LoadingContainer>
              <LoadingSvg />
            </LoadingContainer>
          )}
          {!loading && (detailsError || error) && (
            <div>
              {detailsError || error}{' '}
              <b>(serial numbers: {errorList.join(', ')})</b>
            </div>
          )}
          {!loading && !error && !_.isEmpty(details) && (
            <Fragment>
              <HeaderContainer>
                <H1>{details.serial_number}</H1>
                <SvgContainer onClick={this.props.close}>
                  <CrossSvg width={25} height={25} />
                </SvgContainer>
              </HeaderContainer>
              <ResourceSection>{t('sensors.detail.sensorInfo')}</ResourceSection>
              <BorderContainer>
                <Grid columns={3} doubling stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.type')}</ResourceItemLabel>
                        <ResourceItem>{details.type}</ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.model')}</ResourceItemLabel>
                        <ResourceItem>{details.model}</ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.firmware')}</ResourceItemLabel>
                        <ResourceItem>
                          {details.firmware_versions
                            ? details.firmware_versions.mcu || '--'
                            : '--'}
                        </ResourceItem>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <div style={{ display: 'flex' }}>
                          <div>
                            <ResourceItemLabel>{t('sensors.detail.machine')}</ResourceItemLabel>
                            {this.state.editMode &&
                              this.state.associatedMachineId &&
                              !this.props.createdMachineId && (
                                <Button
                                  text
                                  fontsize="12px"
                                  onClick={this.dissociateSensor}
                                >
                                  {t('sensors.detail.dissociate')}
                                </Button>
                            )}
                            {this.renderField(
                              'select',
                              '',
                              this.state.options.machine,
                              details.machine,
                              !!this.state.associatedMachineId ||
                                this.props.createdMachineId,
                              'machine',
                              true
                            )}
                          </div>
                        </div>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        {this.renderField(
                          'select',
                          t('sensors.detail.component'),
                          this.state.options.component,
                          details.component,
                          false,
                          'component',
                          true
                        )}
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        {this.renderField(
                          'select',
                          t('sensors.detail.location'),
                          this.state.options.location.filter(
                            l => l.component_id === details.component
                          ),
                          details.location,
                          false,
                          'location'
                        )}
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                  <SiteReassignSection
                    user={user}
                    currentAccount={this.props.currentAccount}
                    editMode={this.state.editMode}
                    getOrganisationSites={this.props.sensorsActions.getOrganisationSites}
                    transferDeviceToSite={this.props.sensorsActions.transferDeviceToSite}
                    getOrganisationId={this.getOrganisationId}
                    getSiteAccountId={this.getSiteAccountId}
                    getTransferDeviceParams={this.getTransferDeviceParams}
                    hasMachineAssociation={this.hasMachineAssociationForReassign}
                    onReassignSuccess={this.handleSiteReassignSuccess}
                    t={t}
                  />
                  <Grid.Row>
                    {!details.temperature_only && (
                      <Grid.Column>
                        <Segment>
                          {this.renderField(
                            'select',
                            t('sensors.detail.orientation'),
                            metadata[details.model].orientation,
                            details.orientation,
                            false,
                            'orientation'
                          )}
                        </Segment>
                      </Grid.Column>
                    )}
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.lastReport')}</ResourceItemLabel>
                        <ResourceItem>
                          {localTimeString(details.last_report)}
                        </ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.lastMeasurement')}</ResourceItemLabel>
                        <ResourceItem>
                          {localTimeString(details.last_measurement)}
                        </ResourceItem>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {['VM3', 'VM4P', 'GSP', 'VM4', 'GS'].includes(details.model) && (
                  <Grid columns={1} doubling stackable>
                    <Grid.Row>
                      <Grid.Column>
                        <Segment>
                          <ResourceItemLabel>{t('sensors.detail.temperatureOnly')}</ResourceItemLabel>
                          {this.state.editMode && isPetasenseAdmin(user) ? (
                            <FlexContainer
                              direction="row"
                              alignItems="center"
                            >
                              <ToggleWrapper
                                onClick={!details.location ? this.handleTemperatureOnlyToggle : undefined}
                                disabled={!!details.location}
                                title={this.getToggleTitle()}
                              >
                                {details.temperature_only ? (
                                  <ToggleOn style={{ color: primaryColor }} />
                                ) : (
                                  <ToggleOff style={{ color: this.props.theme.colors.greyD }} />
                                )}
                              </ToggleWrapper>
                            </FlexContainer>
                          ) : (
                            <ResourceItem>
                              {details.temperature_only ? t('sensors.detail.enabled') : t('sensors.detail.disabled')}
                            </ResourceItem>
                          )}
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              </BorderContainer>
              <ResourceSection>{t('sensors.detail.batteryWireless')}</ResourceSection>
              <BorderContainer>
                <Grid columns={3}>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.batteryLevel')}</ResourceItemLabel>
                        <FlexContainer direction="row">
                          <BatteryIcon batteryLevel={details.battery_level} />
                        </FlexContainer>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.wifiSignal')}</ResourceItemLabel>
                        <FlexContainer direction="row">
                          {_.isNull(details.wifi_signal) && (
                            <div
                              title={
                                details.wifi_rssi &&
                                t('sensors.detail.lastWifiRssiTitle', { value: details.wifi_rssi })
                              }
                            >
                              <ResourceItem>{t('sensors.detail.na')}</ResourceItem>
                            </div>
                          )}
                          {!_.isNull(details.wifi_signal) && (
                            <WiFiSvg wifiLevel={details.wifi_signal} />
                          )}
                          {!_.isNull(details.wifi_signal) && details.wifi_rssi && (
                            <WifiLabel>
                              <ResourceItem>
                                {details.wifi_rssi} dB
                              </ResourceItem>
                            </WifiLabel>
                          )}
                        </FlexContainer>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.wifiSsid')}</ResourceItemLabel>
                        <FlexContainer direction="row">
                          {_.isNull(details.wifi_ssid) && (
                            <div>
                              <ResourceItem>{t('sensors.detail.na')}</ResourceItem>
                            </div>
                          )}
                          {details.wifi_ssid && (
                            <WifiLabel>
                              <ResourceItem>{details.wifi_ssid}</ResourceItem>
                            </WifiLabel>
                          )}
                        </FlexContainer>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {this.props.editMode && ['VM3', 'VM4P', 'GSP', 'VM4', 'GS'].includes(details.model) && (
                  <Grid columns={4} doubling stackable>
                    <Grid.Row columns={1}>
                      <Grid.Column>
                        <Segment>
                          <RBAC
                            yes={(
                                <Accordion
                                  title={t('sensors.detail.wifiSettings')}
                                  color="grey"
                                  fontsize="12px"
                                  marginbottom="18px"
                                >
                                <WifiSetting
                                  ssid={ssid}
                                  passphrase={passphrase}
                                  errorMessages={errorMessages}
                                  wifi_schedule_date={wifi_schedule_date}
                                  wifi_schedule_time={wifi_schedule_time}
                                  preferredTimeOptions={
                                    this.preferredTimeOptions
                                  }
                                  handleInputClick={this.handleInputClick}
                                />
                                </Accordion>
                           )}
                          />
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
                {this.props.editMode && ['VM3', 'VM1', 'VM2', 'VM4P', 'VM4'].includes(details.model) && (
                  <Grid columns={4} doubling stackable>
                    <Grid.Row columns={1}>
                      <Grid.Column>
                        <Segment>
                          <RBAC
                            yes={(
                                <Accordion
                                  title={t('sensors.detail.preferredAPSettings')}
                                  color="grey"
                                  fontsize="12px"
                                  marginbottom="18px"
                                >
                                  <Button
                                    text
                                    fontsize="12px"
                                    onClick={this.clearAPSettings}
                                    paddingLeft="0"
                                    paddingBottom="10px"
                                  >
                                    {t('sensors.detail.clearAPSettings')}
                                  </Button>
                                <PreferredAPSettings
                                  bssid={bssid}
                                  channel={channel}
                                  errorMessages={errorMessages}
                                  handleInputClick={this.handleInputClick}
                                />
                                </Accordion>
                           )}
                          />
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              </BorderContainer>
              <ResourceSection>{t('sensors.detail.measurementSettings')}</ResourceSection>
              <BorderContainer>
                <Grid columns={3} doubling stackable>
                  {!details.utilization_detection &&
                    details.bluetooth_p2p_enabled &&
                    details.master_device && (
                      <FlexContainer marginbottom="0.5em" margintop="0.8em">
                        <Info aria-hidden="true" />
                        <TextLabel>
                          {t('sensors.detail.masterMoteBluetooth', { serial: details.master_device })}
                        </TextLabel>
                      </FlexContainer>
                  )}
                  <Fragment>
                    {this.state.editMode && debugActive && (
                      <DebugHintLabel>
                        {t('sensors.detail.debugModeEditDisabled', {
                          defaultValue: "Measurement settings can't be changed while debug mode is active."
                        })}
                      </DebugHintLabel>
                    )}
                    <Grid.Row>
                      <Grid.Column>
                        <Segment>
                          <ResourceItemLabel>{t('sensors.detail.schedule')}</ResourceItemLabel>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px'
                            }}
                          >
                            <ResourceItem>
                              {translateScheduleTypeLabel(
                                t,
                                details.state_based_measurement,
                                details.overall.type
                              )}
                            </ResourceItem>
                            {(details.state_based_measurement ||
                              details.overall.type === 'schedule_based' ||
                              details.overall.type === 'state_based') && (
                              <ScheduleButton
                                text
                                disabled={this.state.editMode && debugActive}
                                onClick={() =>
                                  this.setState({ openScheduler: true })
                                }
                                fontSize="12px"
                                paddingBottom=""
                              >
                                {this.state.editMode ? t('sensors.detail.set') : t('sensors.detail.view')}
                              </ScheduleButton>
                            )}
                          </div>
                        </Segment>
                      </Grid.Column>
                      {['VM3', 'VM4P', 'GSP', 'VM4', 'GS'].includes(details.model) && (
                        <Grid.Column>
                          <Segment>
                            {this.renderField(
                              'select',
                              t('sensors.detail.reportingInterval'),
                              this.filterReportingIntervals(),
                              details.reporting_interval,
                              debugActive,
                              'reporting_interval',
                              false,
                              true
                            )}
                          </Segment>
                        </Grid.Column>
                      )}
                      {['VM3', 'VM4P', 'GSP', 'VM4', 'GS'].includes(details.model) && !details.temperature_only && (
                        <>
                          <Grid.Column>
                            <Segment>
                              <ResourceItemLabel>{t('sensors.detail.fsRange')}</ResourceItemLabel>
                              {this.renderField(
                                'select',
                                '',
                                ACCELEROMETER_FS_RANGES,
                                details.fs_range,
                                debugActive,
                                'fs_range'
                              )}
                            </Segment>
                          </Grid.Column>
                        </>
                      )}
                    </Grid.Row>
                    {this.showsMagnetometerFsRange(details) && (
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.magnetometerFsRange')}</ResourceItemLabel>
                            {this.renderField(
                              'select',
                              '',
                              MAGNETOMETER_FS_RANGES,
                              details.magnetometer_fs_range,
                              debugActive,
                              'magnetometer_fs_range'
                            )}
                          </Segment>
                        </Grid.Column>
                      </Grid.Row>
                    )}
                  </Fragment>
                  {!details.temperature_only && (
                    <>
                      <ResourceSubSection>{t('sensors.detail.sampling')}</ResourceSubSection>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            {this.renderField(
                              'select',
                              t('sensors.detail.highResolution'),
                              metadata[details.model].measurement_settings.sampling[
                                '2'
                              ],
                              highRes.sampling,
                              debugActive,
                              'high_res.sampling'
                            )}
                          </Segment>
                        </Grid.Column>
                        <Grid.Column>
                          <Segment>
                            {this.renderField(
                              'select',
                              t('sensors.detail.fullBandwidth'),
                              metadata[details.model].measurement_settings.sampling[
                                '1'
                              ],
                              fullBandwidth.sampling,
                              debugActive,
                              'full_bandwidth.sampling'
                            )}
                          </Segment>
                        </Grid.Column>
                      </Grid.Row>
                      <ResourceSubSection>
                        {t('sensors.detail.highPassFilterCutoff')}
                      </ResourceSubSection>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            {this.renderField(
                              'select',
                              t('sensors.detail.highResolution'),
                              metadata[details.model].measurement_settings
                                .high_pass_filter_cutoff['2'],
                              highRes.high_pass_filter_cutoff,
                              debugActive,
                              'high_res.high_pass_filter_cutoff'
                            )}
                          </Segment>
                        </Grid.Column>
                        <Grid.Column>
                          <Segment>
                            {metadata[details.model].measurement_settings
                              .high_pass_filter_cutoff['1'] &&
                            this.renderField(
                              'select',
                              t('sensors.detail.fullBandwidth'),
                              metadata[details.model].measurement_settings
                                .high_pass_filter_cutoff['1'],
                              fullBandwidth.high_pass_filter_cutoff,
                              debugActive,
                              'full_bandwidth.high_pass_filter_cutoff'
                            )}
                          </Segment>
                        </Grid.Column>
                      </Grid.Row>
                    </>
                  )}
                </Grid>
              </BorderContainer>
              {(isPetasenseAdmin(user) || isPetasenseViewer(user) || isPartnerAdmin(user)) && (
                <>
                  <ResourceSection>{t('sensors.detail.advancedDeviceDetails')}</ResourceSection>
                  <BorderContainer>
                    <Grid columns={3} doubling stackable>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.deviceId')}</ResourceItemLabel>
                            <ResourceItem>{details.device_id}</ResourceItem>
                          </Segment>
                        </Grid.Column>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.macAddress')}</ResourceItemLabel>
                            <ResourceItem>{details.mac_address}</ResourceItem>
                          </Segment>
                        </Grid.Column>
                        {isPetasenseAdmin(user) && (
                          <Grid.Column>
                            {details.agent_url && (
                              <Segment>
                                <ResourceItemLabel>{t('sensors.detail.impPage')}</ResourceItemLabel>
                                <ResourceItem>
                                  <AnalysisButton text>
                                    <a
                                      href={getImpUrl(details.device_id)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: primaryColor,
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '1.2px'
                                      }}
                                    >
                                      {t('sensors.detail.url')}
                                    </a>
                                  </AnalysisButton>
                                </ResourceItem>
                              </Segment>
                            )}
                          </Grid.Column>
                        )}
                      </Grid.Row>
                      <Grid.Row columns={3}>
                        {isPetasenseAdmin(user) && (
                          <>
                            {details.model === 'VM1' || details.model === 'VM2' ? (
                              <Grid.Column>
                                <Segment>
                                  <ResourceItemLabel>{t('sensors.detail.logs')}</ResourceItemLabel>
                                  <ResourceItem>
                                    <a
                                      href={getFullEndPointUrl(ENDPOINT.DOWNLOAD_DEVICES_LOGS(details.id))}
                                      download
                                      style={{
                                        color: primaryColor,
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '1.2px'
                                      }}
                                    >
                                      {t('sensors.detail.download')}
                                    </a>
                                  </ResourceItem>
                                </Segment>
                              </Grid.Column>
                            ) : (
                              ['VM3', 'VM4P', 'GSP', 'VM4', 'GS'].includes(details.model) && (
                                <>
                                  <Grid.Column>
                                    <Segment>
                                      <ResourceItemLabel>{t('sensors.detail.logs')}</ResourceItemLabel>
                                      <ResourceItem>
                                        <a
                                          href={getDeviceGCPLogsUrl(details.serial_number)}
                                          style={{
                                            color: primaryColor,
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            letterSpacing: '1.2px'
                                          }}
                                          target="blank"
                                        >
                                          {t('sensors.detail.viewAction')}
                                        </a>
                                      </ResourceItem>
                                    </Segment>
                                  </Grid.Column>
                                </>
                              )
                            )}
                          </>
                        )}
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.analysis')}</ResourceItemLabel>
                            <ResourceItem>
                              <AnalysisButton
                                text
                                onClick={this.handleLogAnalysisClick}
                                fontsize="12px"
                                paddingBottom=""
                              >
                                {t('sensors.detail.viewAnalysis')}
                              </AnalysisButton>
                            </ResourceItem>
                          </Segment>
                        </Grid.Column>
                        {['VM3', 'VM4P', 'GSP', 'VM4', 'GS'].includes(details.model) && (
                          <Grid.Column>
                            <Segment>
                              <ResourceItemLabel>
                                {t('sensors.detail.lastReportedInfo')}
                              </ResourceItemLabel>
                              <ResourceItem>
                                <AnalysisButton
                                  text
                                  onClick={this.handleLastReportedClick}
                                  fontsize="12px"
                                  paddingBottom=""
                                >
                                  {t('sensors.detail.viewAction')}
                                </AnalysisButton>
                              </ResourceItem>
                            </Segment>
                          </Grid.Column>
                        )}
                      </Grid.Row>
                      <Grid.Row>
                      <Grid.Column>
                        <Segment>
                          <ResourceItemLabel>{t('sensors.detail.config')}</ResourceItemLabel>
                          <ResourceItem style={{ color: 'red' }}>
                                    <a
                                      href={getFullEndPointUrl(ENDPOINT.DEVICE_CONFIG(details.serial_number))}
                                      style={{
                                        color: primaryColor,
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '1.2px'
                                      }}
                                      target="blank"
                                    >
                                      {t('sensors.detail.viewAction')}
                                    </a>
                          </ResourceItem>
                        </Segment>
                      </Grid.Column>
                      <Grid.Column>
                        <Segment>
                          <ResourceItemLabel>{t('sensors.detail.configHistories')}</ResourceItemLabel>
                          <ResourceItem style={{ color: 'red' }}>
                                    <a
                                      href={getFullEndPointUrl(ENDPOINT.DEVICE_CONFIG_HISTORY(details.serial_number))}
                                      style={{
                                        color: primaryColor,
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '1.2px'
                                      }}
                                      target="blank"
                                    >
                                      {t('sensors.detail.viewAction')}
                                    </a>
                          </ResourceItem>
                        </Segment>
                      </Grid.Column>
                      {details.last_battery_change_time && (
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.lastBatteryChangeTime')}</ResourceItemLabel>
                            <ResourceItem>{localTimeString(details.last_battery_change_time)}  ({t('sensors.detail.daysAgo', { days: this.calculateDaysDifference(details.last_battery_change_time) })})</ResourceItem>
                          </Segment>
                        </Grid.Column>
                      )
                      }
                      </Grid.Row>
                      {isPetasenseAdmin(user) && WIFI_BACKOFF_MODELS.includes(details.model) && (
                        <Grid.Row>
                          <Grid.Column>
                            <Segment>
                              <ResourceItemLabel>{t('sensors.detail.wifiBackoff')}</ResourceItemLabel>
                              {this.state.editMode ? (
                                <FlexContainer direction="row" alignItems="center">
                                  <ToggleWrapper
                                    onClick={this.handleWifiBackoffToggle}
                                    title={t('sensors.detail.wifiBackoffHint')}
                                  >
                                    {details.wifi_backoff !== false ? (
                                      <ToggleOn style={{ color: primaryColor }} />
                                    ) : (
                                      <ToggleOff style={{ color: this.props.theme.colors.greyD }} />
                                    )}
                                  </ToggleWrapper>
                                </FlexContainer>
                              ) : (
                                <ResourceItem>
                                  {details.wifi_backoff !== false
                                    ? t('sensors.detail.enabled')
                                    : t('sensors.detail.disabled')}
                                </ResourceItem>
                              )}
                            </Segment>
                          </Grid.Column>
                        </Grid.Row>
                      )}
                    </Grid>
                  </BorderContainer>
                </>
              )}
              {['VM4', 'VM4P', 'GS', 'GSP', 'VM4P-IS'].includes(details.model) && (
                <EventDetectionSection
                  sensor={details}
                  eventDetection={details.event_detection}
                  savedEventDetection={(this.getPropsSensor() || {}).event_detection}
                  editMode={this.state.editMode}
                  onChange={this.handleEventDetectionChange}
                  eventMetadata={this.props.eventMetadata}
                  vibrationDirectionPreference={
                    (this.props.currentAccount && this.props.currentAccount.preferences && this.props.currentAccount.preferences.vibration_direction_preference) || 1
                  }
                  temperatureOnly={details.temperature_only || false}
                  onValidationChange={this.handleEventDetectionValidationChange}
                  getAlarmThresholds={this.props.eventConfigActions.getAlarmThresholds}
                  getDashboardCouplingEligibility={
                    this.props.eventConfigActions.getDashboardCouplingEligibility
                  }
                  user={this.props.user}
                />
              )}
              {showLogAnalysisModal && (
                <DeviceParameterAnalysis
                  deviceId={details.id}
                  last_report={localTimeString(details.last_report)}
                  model={details.model}
                  serialNumber={details.serial_number}
                  onCancel={() =>
                    this.setState({ showLogAnalysisModal: false })
                  }
                />
              )}
              {showLastReportedModal && (
                <DeviceReportedInfoModal
                  serialNumber={details.serial_number}
                  onCancel={() =>
                    this.setState({ showLastReportedModal: false })
                  }
                />
              )}
              {this.state.editMode && (
                <ButtonsContainer>
                  <SaveButton
                    disabled={!saveEnabled}
                    onClick={this.onClickCheckAggressive}
                  >
                    {t('sensors.detail.save')}
                  </SaveButton>
                  <SaveButton
                    secondary="#3C3D3A"
                    disabled={!saveEnabled}
                    onClick={this.onCancel}
                  >
                    {t('sensors.detail.cancel')}
                  </SaveButton>
                </ButtonsContainer>
              )}
            </Fragment>
          )}
        </Container>
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  metadata: state.sensors.metadata.metadata,
  details: state.sensors.details.details,
  loading: state.sensors.details.loading,
  detailsError: state.sensors.details.error,
  updating: state.sensors.details.updating,
  errorList: state.sensors.details.errorList,
  user: state.user.user,
  primaryColor: state.companyReducer.partner.theme.primaryColor,
  eventMetadata: state.sensors.metadata.eventMetadata.data,
  currentAccount: state.currentAccount
});
const mapDispatchToProps = dispatch => ({
  sensorsActions: bindActionCreators(sensorsActions, dispatch),
  eventConfigActions: bindActionCreators(eventConfigActions, dispatch)
});
// styled-components v3 withTheme does not forward refs; use innerRef so the
// connect wrappedInstance resolves to VibrationMote, not the WithTheme wrapper.
const VibrationMoteWithTheme = withTheme(VibrationMoteBase);
const VibrationMoteThemeRef = React.forwardRef((props, ref) => (
  <VibrationMoteWithTheme {...props} innerRef={ref} />
));
VibrationMoteThemeRef.displayName = 'VibrationMoteThemeRef';

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true
})(withTranslation(undefined, { withRef: true })(VibrationMoteThemeRef));
